import React, { Component } from 'react';
import { RefreshCcw, ShieldAlert } from 'lucide-react';

class GlobalErrorHandler extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Kernel Panic:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="global-error-screen" className="fixed inset-0 z-[9999] bg-[#0000aa] text-white font-mono flex flex-col items-center justify-center p-8 overflow-auto selection:bg-white selection:text-blue-900">
          <div className="max-w-3xl w-full space-y-8">
            <div className="flex items-center gap-4 mb-8">
              <div className="bg-white text-blue-900 p-2"><span className="font-bold text-xl px-2">FATAL_EXCEPTION</span></div>
              <ShieldAlert size={48} className="animate-pulse" />
            </div>
            <h1 className="text-3xl font-bold mb-4">A problem has been detected and RetailCLIQ has been shut down to prevent damage to your data.</h1>
            <p className="text-lg leading-relaxed">KERNEL_MODE_EXCEPTION_NOT_HANDLED</p>
            <div className="bg-[#000088] border border-white/20 p-6 my-6 font-mono text-sm shadow-xl">
              <p className="mb-2 text-yellow-300">Technical Information:</p>
              {this.state.error && <p className="font-bold text-red-300">ERROR: {this.state.error.toString()}</p>}
              {this.state.errorInfo && (
                <details className="cursor-pointer mt-4">
                  <summary className="text-blue-300 hover:text-white outline-none">View Stack Trace</summary>
                  <pre className="mt-4 whitespace-pre-wrap text-[10px] opacity-70 leading-tight">{this.state.errorInfo.componentStack}</pre>
                </details>
              )}
            </div>
            <button data-testid="error-restart-btn" onClick={this.handleReset} className="bg-white text-blue-900 hover:bg-gray-200 px-6 py-3 font-bold uppercase tracking-widest text-sm rounded-lg shadow-lg transition-all flex items-center gap-2">
              <RefreshCcw size={18} /> System Restart
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorHandler;
